<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import Process from '@/components/cloudCounter/Process.vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const goNextPage = () => {
    router.push({ name: 'cloudCounterVideoOperationVerify' });
}

// #region 申請保單
const policyInfo = ref(null);

// 串接...
policyInfo.value = { key: '1068302189-00', value: 'XWS5 富邦人壽新平準終身壽險' };
// #endregion

// #region 新要保人姓名
const newApplicantName = ref(null);

// 串接...
newApplicantName.value = {
    boxList: [
        {
            title: '要保人基本資料',
            list: [
                { key: '姓名', value: '林中富' },
                { key: '身分證號碼', value: 'A1*****789' },
                { key: '國籍', value: '中華民國' },
                { key: '出生日期', value: '86/05/**' },
                { key: '與被保險人的關係', value: '子女' }
            ]
        },
        {
            title: '職業內容',
            list: [
                { key: '服務單位', value: '大雨股份有限公司' },
                { key: '營業性質', value: '資訊業' },
                { key: '職位', value: '一般職員' },
                { key: '工作內容', value: '寫程式' },
                { key: '職業代碼', value: '資訊業系統工程師' },
                { key: '兼職工作內容', value: '測試硬體' },
                { key: '兼職代碼', value: '硬體測試人員' }
            ]
        },
        {
            title: '要保人聯絡資訊',
            list: [
                { key: '收費地址', value: '台北市信義區市府路********' },
                { key: '收費地址市話', value: '02-1*****11' },
                { key: '住所（戶籍地址）', value: '台北市信義區市府路********' },
                { key: '住所（戶籍地址）市話', value: '02-1*****11' },
                { key: '行動電話', value: '091*****33' },
                { key: 'E-mail', value: '****efg@email.com' }
            ]
        },
    ]
};
// #endregion

const infoBoxVisble = ref(false);
const okHandel = () => {

};

</script>

<template>

    <!-- 要保人變更 -->
    <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="1"></Process>
        </div>

        <div class="pb-6">
            <h2 class="pb-3 text-2xl font-bold">
                申請紀錄
            </h2>
            <CaseBox :caseBox="{
                boxList: [
                    {
                        list: [
                            { key: '申請日期', value: '113/06/15' },
                            { key: '申請項目', value: '要保人變更' },
                            { key: '受理案號', value: '114-WBP-0023902' },
                            { key: '視訊時間', value: '113/07/02 10:00~11:00' },
                            { key: '處理狀態', value: '待視訊確認中' }
                        ]
                    }
                ]
            }" />
        </div>

        <h2 class="pb-3 text-2xl font-bold">
            申請明細
        </h2>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                申請保單
            </h3>
            <CaseBox :caseBox="policyInfo"></CaseBox>
        </div>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                新的要保人資料
            </h3>
            <CaseBox :caseBox="newApplicantName"></CaseBox>
        </div>

        <div class="pb-4">
            <h3 class="pb-4 text-xl font-bold">
                取消豁免附約
            </h3>
            <CaseBox class="font-bold">
                <a href="#">富邦人壽保險附約條款（WP）</a>
            </CaseBox>
        </div>

        <div class="text-center">
            <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請</button>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">開始視訊</button>
        </template>

    </Layout>

    <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？" type="confirm"
        :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }">
    </InfoBox>

</template>

<style scoped></style>
